import { useState } from "react";
import { Link } from "react-router-dom";
import { useAkcjePrzegladu } from "../../hooks/usePrzegladRecenzji.js";
import { tekstBledu } from "../../lib/recenzja.js";
import { IconPobierz, IconSukces } from "../icons/index.js";
import { Button } from "../ui/Button.js";
import { useToast } from "../ui/Toast.js";

/**
 * Baner sukcesu. Prymityw Banner zna tylko blad, ostrzezenie i informacje, a potwierdzenie "przejrzane" to stan
 * pozytywny: te same klasy .banner, wariant success zdefiniowany w recenzja.css (z tokenow --status-success-*).
 * Stan trwa, dopoki trwa (BN-1), i znika po cofnieciu zakonczenia, wiec to baner, a nie toast.
 */
function BanerPrzejrzanej({ powrot }: { powrot: string }): React.JSX.Element {
  return (
    <div className="banner rec-baner" data-variant="success" role="status">
      <span className="banner__icon" aria-hidden="true">
        <IconSukces size={20} />
      </span>
      <div className="banner__content">
        <p className="banner__text">
          Dziękujemy. Ta rozmowa jest oznaczona jako przejrzana. Możesz do niej wrócić i poprawić uwagi.
        </p>
      </div>
      <div className="banner__action-slot">
        <Link className="btn btn--secondary" to={powrot}>
          Wszystkie rozmowy
        </Link>
      </div>
    </div>
  );
}

/**
 * Koniec przegladu: "Zakoncz przeglad tej rozmowy" (jedyny primary na widoku, B-2) i "Pobierz Word". Zakonczenie mozna
 * cofnac, a po nim wciaz mozna poprawiac uwagi.
 */
export function AkcjeKoncowe({ przejrzana, powrot }: { przejrzana: boolean; powrot: string }): React.JSX.Element {
  const akcje = useAkcjePrzegladu();
  const toast = useToast();
  const [zmieniaStan, setZmieniaStan] = useState(false);
  const [pobiera, setPobiera] = useState(false);

  async function przelaczPrzejrzana(): Promise<void> {
    if (zmieniaStan) return;
    setZmieniaStan(true);
    try {
      await akcje.ustawPrzejrzana(!przejrzana);
    } catch (err) {
      toast.blad(tekstBledu(err));
    } finally {
      setZmieniaStan(false);
    }
  }

  async function pobierzWord(): Promise<void> {
    if (pobiera) return;
    setPobiera(true);
    try {
      await akcje.pobierzWord();
      toast.sukces("Plik Word pobrany.");
    } catch (err) {
      toast.blad(tekstBledu(err));
    } finally {
      setPobiera(false);
    }
  }

  return (
    <>
      <div className="rec-akcje">
        <Button wariant={przejrzana ? "secondary" : "primary"} zajety={zmieniaStan} onClick={() => void przelaczPrzejrzana()}>
          {przejrzana ? "Cofnij zakończenie przeglądu" : "Zakończ przegląd tej rozmowy"}
        </Button>
        <Button wariant="secondary" zajety={pobiera} onClick={() => void pobierzWord()}>
          {!pobiera && <IconPobierz />}
          {pobiera ? "Przygotowuję plik..." : "Pobierz Word"}
        </Button>
      </div>
      {przejrzana && <BanerPrzejrzanej powrot={powrot} />}
    </>
  );
}
